import { Component, EventEmitter, Input, Output } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Component({
    selector: "app-on-off-toggle",
    templateUrl: "./on-off-toggle.component.html",
    styleUrls: ["./on-off-toggle.component.scss"],
})
export class OnOffToggleComponent {
    @Input() public isOn = true;
    @Input() public editable = true;
    @Input() public changeValueFromOutside$?: BehaviorSubject<boolean>;
    @Output() public toggleOnClick = new EventEmitter<boolean>();

    public toggleChanged(value: boolean) {
        this.isOn = value;
        this.toggleOnClick.emit(value);
    }
}
